import "@babel/polyfill"
class dataServices{
    constructor(){
        this.baseAddress = '/modService/ListController/';
    }

    // this.baseAddress = '/mod/ListController/GetModItems?webUrl='; HebDate?webUrl=
    // this.baseAddress = 'http://www.spwebapi.mod.gov.il/api/ListController/GetModItems?webUrl='

    getSPListItems(siteUrl,listName,viewName,showAttach,hebDate){
     //   const address = `${this.baseAddress}('${listName}')/Items?$select=${fileds.join(',')}`;
     listName=encodeURIComponent(listName);
     viewName=encodeURIComponent(viewName);

     const address = `${this.baseAddress}GetModItems?webUrl=${siteUrl}&listName=${listName}&viewName=${viewName}${hebDate||''}${showAttach||''}`;
        return axios.get(address);
    }
    setContactUsData(siteUrl,data)
    {
        let address =`${this.baseAddress}SetContactUs?webUrl=${siteUrl}`;
        return axios.post(address,data)  ;              
     }
}
 
export default new dataServices();

// import "@babel/polyfill"
// class dataServices{
//     constructor(){
//         this.baseAddress = '/modService/ListController/GetModItems?webUrl=';
//     }

//     // this.baseAddress = '/mod/ListController/GetModItems?webUrl=';
//     // this.baseAddress = 'http://www.spwebapi.mod.gov.il/api/ListController/GetModItems?webUrl='

//     getSPListItems(siteUrl,listName,viewName){
//      //   const address = `${this.baseAddress}('${listName}')/Items?$select=${fileds.join(',')}`;
//      listName=encodeURIComponent(listName);
//      viewName=encodeURIComponent(viewName);
//      const address = `${this.baseAddress}${siteUrl}&listName=${listName}&viewName=${viewName}`;
//         return axios.get(address);
//     }
//     setContactUsData(siteUrl,data)
//     {
//         let address =`${this.baseAddress}SetContactUs?webUrl=${siteUrl}`;
//         return axios.post(address,data)  ;              
//     }
// }

// export default new dataServices(); 